/* eslint-disable no-inner-declarations */

(function ($) {
    $(function () {
        // Initialize mobile menu
        $('.mobile-nav').multilevelNav({
            'childMenuTogglerSymbol':
                '<svg class="nav-plus" version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">' +
                '<rect class="nav-plus__vert" x="13" width="4" height="30"/>' +
                '<rect class="nav-plus__horiz" x="13" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 30 3.552714e-15)" width="4" height="30"/>' +
                '</svg>'
        });

        $('.mobile-nav').find('.mln__level-1 > .mln__child-controls > a').each(function () {
            $(this).attr('tabindex', '-1');
        })

        // Close search collapse and mobile expander when clicking off them
        $(document).on('click', function (event) {
            var eventTarget = $(event.target);

            // Close seach collapse
            if (
                eventTarget.closest('.mobile-search').length === 0 &&
                $('.mobile-search__collapse.show').length
            ) {
                $('#mobileSearchCollapse').collapse('hide');
            }

            // Close mobile expander
            if (
                eventTarget.closest('.mln__expander--showing').length === 0 &&
                eventTarget.closest('.mobile-nav__expand-btn').length === 0 &&
                !eventTarget.hasClass('mobile-nav__expand-btn') &&
                $('.mln__expander--showing').length
            ) {
                $('.mobile-nav__expand-btn').trigger('click');
            }
        });

        // Close search when pressing escape key
        $('.mobile-search__collapse, .mobile-search__expand-btn').on('keyup', function (event) {
            var eventTarget = $(event.target);

            if (
                event.key === 'Escape' &&
                eventTarget.closest('.mobile-search').length &&
                $('.mobile-search__collapse.show').length
            ) {
                $('#mobileSearchCollapse').collapse('hide');
                $('.mobile-search__expand-btn').focus();
            }
        });

        // Close mobile nav expander when pressing escape key
        $('.mln__expander, .mobile-nav__expand-btn').on('keyup', function (event) {
            if (
                event.key === 'Escape' &&
                $('.mobile-nav').find('.mln__has-child--showing').length === 0 &&
                $('.mln__expander--showing').length
            ) {
                $('.mobile-nav__expand-btn')
                    .trigger('click')
                    .focus();
            }
        });

        if (window.location.hash) {
            // console.log(window.location.hash);
            var hashName = window.location.hash.substring(window.location.hash.indexOf('#') + 1);
            var aTag = $("a[name='" + hashName + "']");
            var header = $(".desktop-header").outerHeight() + 10;
            $('html,body').animate({ scrollTop: aTag.offset().top - header }, 'fast');
        }
    });

    // Initialize desktop menu
    $('.desktop-nav').multilevelNav({
        'hoverIntent': true,
        'hoverIntentTimeout': 200,
        'excludeLevel': 2,
        // 'toggleOnClickOnly': true,
        'wholeLinkToggler': true,
    });

    // Render controls element
    if ($('body').data('show-grid-overlay') === true || $('body').data('show-image-specs') === true) {
        $('<div>')
            .addClass('helper-controls container')
            .prependTo('.site-header')
            .css({
                'position': 'fixed',
                'width': 'auto',
                'top': '0',
                'left': '0',
                'font-size': '11px',
                'padding': '3px 7px',
                'z-index': '20000',
                'background': '#fff',
                'border-bottom-right-radius': '3px',
            });
    }

    // Initialize grid overlay
    $.fn.gridOverlay({
        'outerPadding': '3rem',
        'controlsParentSelector': '.helper-controls'
    });

    // Initialize image spec tags
    $.fn.imageSpecs({
        'imageExcludeSelectors': '.site-header__logo-full, .site-header__logo-acronym, .site-footer__logo',
        'linkColor': '#005587',
        'controlsParentSelector': '.helper-controls'
    });

    // Initialize font spec
    $(window).on('load', function () {
        $.fn.fontSpecs();
    });

    // Initialize hero video
    $('.hero').heroVideo();

    // Toggle text on toggle button
    toggleText('.collapse');

    // Render sort by dropdown elements for styled select
    $('.sort-by__select').renderSelectToDropdownElements({
        'buttonClass': 'sort-by__toggle',
        'bootstrapDropdown': true
    });

    // Sort by select to dropdown initialization
    var sortBySelect = $('.sort-by__toggle').closest('.select-to-dropdown');
    sortBySelect
        .addClass('w-100')
        .selectToDropdown();

    // Render dropdown elements for styled select
    $('.styled-select').renderSelectToDropdownElements({
        'buttonClass': 'pager__select-toggle',
        'bootstrapDropdown': true
    });

    // Select to dropdown initialization
    var pagerSelect = $('.pager__select-toggle').closest('.select-to-dropdown');
    pagerSelect.selectToDropdown();

    // Dropdown select items wrap "of and number" in sr-only span
    $('.pager .dropdown-menu').each(function () {
        var $this = $(this);
        var ddItem = $this.find('.dropdown-item');

        ddItem.each(function () {
            var $ddItem = $(this);
            $ddItem.html($ddItem.text().replace(/(\w+\s\w+?)$/, '<span class="sr-only">$1</span>'));
        });
    });

    // Go to top of results when bottom pager is adjusted
    var pagerTargets = $('.pager--bottom').find('.pager__prev, .pager__next, .pager__select');
    var productListingContainer = $('.product-listing-loading');
    var siteHeader = $('.desktop-header');

    pagerTargets.on('click change', function () {
        var scrollToOffset = (siteHeader.is(':visible')) ? (siteHeader.outerHeight() + 20) : 20;

        if (productListingContainer.length) {
            $('html, body').animate({
                scrollTop: productListingContainer.offset().top - scrollToOffset
            });
        }
    });

    syncRadios('#checkBoxViewImages', '#checkBoxViewImages2');
    syncRadios('#checkBoxViewImages2', '#checkBoxViewImages');
    syncRadios('#checkBoxViewRenders', '#checkBoxViewRenders2');
    syncRadios('#checkBoxViewRenders2', '#checkBoxViewRenders');

    // Add body class when render radio is checked
    $('#checkBoxViewRenders, #checkBoxViewRenders2').on('change', function () {
        if ($(this).is(':checked')) {
            $('body').addClass('js-renders-checked');
        } else {
            $('body').removeClass('js-renders-checked');
        }
    });

    let isDocReady = true;

    $(document).ajaxSuccess(function () {
        // Rerun checkbox/radio styled js on ajax success
        checkboxAndRadioStyled();

        // Refresh sort by select dropdown
        sortBySelect.refreshSelectToDropdown();

        // Refresh pager select dropdown
        pagerSelect.refreshSelectToDropdown();

        // Sync current page to select pager dropdown item on page load
        setTimeout(function () {
            updatePagerDisplay('.pager', 'reset', true);
        }, 300);

        // Sync pager selects
        syncPagerSelects();

        // Run filter collapse function
        filtersCollapseInit();

        // Add requird asterisk
        addAsteriskToRequiredSelectOption();

        if (isDocReady === true) {
            $('.radio-tabs__list .radio-tabs__item')
                .first()
                .find('.radio-tabs__radio')
                .prop('checked', 'checked');

            isDocReady = false;
        }
    });

    // Fix collapse issues between old vs new bootstrap
    $('[data-toggle="collapse"').each(function () {
        var $collapse = $(this);
        var collapseID = $collapse.attr('aria-controls');
        var collapseEl = $('#' + collapseID);

        if (!collapseEl.is('.in')) {
            $collapse.addClass('collapsed');
        }
    });

    // Refresh styled checkboxes/radios
    $('.filters').on('click', function () {
        checkboxAndRadioStyled();
    });

    // Run filter collapse function
    filtersCollapseInit();

    // Related links block aria fix.
    var relatedAccordionToggle = $('.relatedlinksblock .accordion-section__status');
    relatedAccordionToggle.on('click keypress', function (e) {
        var relatedAccordion = $(this).closest('.relatedlinksblock');
        relatedAccordion
            .find('[aria-expanded="true"]')
            .not($(this))
            .attr('aria-expanded', 'false');
    });

    // Pager popover fix
    if ($('.pager [data-toggle="pagerpopover"]').length) {
        // Toggle click
        $('.pager [data-toggle="pagerpopover"]').on('click', function (e) {
            legacyPagerToggle($(this));
        });

        // Close on escape key
        $('.pager').on('keydown', function (e) {
            if (e.key === 'Escape' && !$(this).find('.popover-content-container').hasClass('hidden')) {
                $(this).find('[data-toggle="pagerpopover"]')
                    .trigger('click')
                    .focus();
            }
        });

        // Close on click off
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.popover-content-container').length && !$(e.target).is('[data-toggle="pagerpopover"]')) {
                $('.pager')
                    .find('.popover-content-container')
                    .not('.hidden')
                    .closest('.pager')
                    .find('[data-toggle="pagerpopover"]')
                    .trigger('click');
            }
        });
    }

    // Filters, view amount and image/render toggle updates
    $('.filters, .radio-tabs').on('click', function (e) {
        pagerSelect.refreshSelectToDropdown();
        updatePagerDisplay('.pager', 'reset');
        $(e.target).focus();
    });

    // Sort by update
    $('#filterBySelect').on('change', function () {
        pagerSelect.refreshSelectToDropdown();
        updatePagerDisplay('.pager', 'reset');
        $(this).focus();
    });

    $(".faq-jump-list").on("click", "a", function (e) {
        e.preventDefault();

        var header = $(".desktop-header").outerHeight() + 10;
        var button = $("button[data-target='" + $(this).attr("href") + "']");
        button.click();
        $('html,body').animate({ scrollTop: button.offset().top - header }, 'fast');
    })

    // Style Episerver form checkboxs
    $('.FormChoice__Input--Checkbox, .FormChoice__Input--Radio')
        .closest('.checkbox')
        .each(function () {
            $(this).addClass('styled');
        });
    checkboxAndRadioStyled();

    // Attempt to fix validation focus issue where focused unvalidated form element is hidden behind the site header
    if ($('.EPiServerForms').length) {
        $$epiforms('.EPiServerForms').on('formsStepValidating', function () {
            var $currentForm = $(this);
            var checkElements = $currentForm.find('input, select, textarea').not('.FormSubmitButton')

            // Listen for focus on first errored element
            checkElements.on('focus', function () {
                var additionalOffsetSpace = 60;
                var headerOffset = ($(window).width() >= 992) ? $('.site-header .desktop-header').outerHeight() + additionalOffsetSpace : additionalOffsetSpace;

                // Jump to errored element once it recieves focus with adjusted offset
                if ($currentForm.find('.ValidationFail').length) {
                    $('html, body').animate({
                        scrollTop: $currentForm.find(document.activeElement).offset().top - headerOffset
                    }, 0);

                    // Remove focus event listener so it only runs once per submit press
                    checkElements.off('focus');
                }
            });
        });
    }

    $(document).ready(function () {
        initializeGDPRCookie();
    });
    

    // Add blank alt tag to images that don't have and alt tag at all
    $('img').not('[alt]').each(function () {
        $(this).attr('alt', '');
    });
})(jQuery);

// Sync up images/render toggle switches
function syncRadios(origEl, syncedEl) {
    $(origEl).on('click keypress', function () {
        if ($(origEl).is(':checked')) {
            $(syncedEl).prop('checked', true);
        } else {
            $(syncedEl).prop('checked', false);
        }
    });
}

// Sync selects function
function syncSelect(origEl, syncedEl) {
    var origSelectDropdown = $(origEl).closest('.select-to-dropdown');
    var syncedElDropdown = $(syncedEl).closest('.select-to-dropdown');

    origSelectDropdown.find('.b-dropdown-item').on('click', function (e) {
        var dataValue = $(this).data('value');
        var optionText = syncedElDropdown.find('.b-dropdown-item[data-value="' + dataValue + '"]').text();

        syncedElDropdown
            .find('.js-item-selected')
            .removeClass('js-item-selected')
            .end()
            .find('.b-dropdown-item[data-value="' + dataValue + '"]')
            .addClass('js-item-selected')
            .end()
            .find('.toggle-text')
            .text(optionText);
    });
}

// Sync pager selects
function syncPagerSelects() {
    setTimeout(function () {
        syncSelect('#currentPageOfSelect', '#currentPageOfSelect2');
        syncSelect('#currentPageOfSelect2', '#currentPageOfSelect');
    }, 1000);
}

function updatePagerDisplay(el, reset, isAjax) {
    var pagerDropdown = $(el);
    var pagerButtons = pagerDropdown.find('.b-dropdown-item, .pager__prev, .pager__next');

    pagerButtons.on('click', function () {
        var pageOfText = $('[data-pagerinfo]').first().attr('data-pagerinfo');
        var pageOfTextSplit = pageOfText.split(' ');
        var currentPage = pageOfTextSplit[1];

        // Remove previous selected class
        pagerDropdown.find('.b-dropdown-item').removeClass('js-item-selected');

        // Add selected class to current item
        pagerDropdown.find('.b-dropdown-item[data-value="' + currentPage + '"]').addClass('js-item-selected');

        // Change toggle button text
        pagerDropdown.find('.toggle-text').html(pageOfText);
    });

    //if (reset === 'reset') {
    //    pagerDropdown
    //        .first()
    //        .find('.b-dropdown-item[data-value="1"]')
    //        .trigger('click');
    //}

    if (isAjax === true && pagerDropdown.length) {
        $('body')
            .attr('tabindex', 0)
            .focus()
            .blur()
            .removeAttr('tabindex');
    }
}

// Fix mobile filter collapse issues
function filtersCollapseInit() {
    setTimeout(function () {
        $('.filters__item-toggle-btn').each(function () {
            var $filterToggle = $(this);

            $filterToggle.on('click keypress', function () {
                var $toggle = $(this);
                var associatedCollapse = $toggle.closest('.filters__item').find('.collapse').first();

                if (associatedCollapse.is('.show')) {
                    $toggle.attr('aria-expanded', false)
                    associatedCollapse.collapse('hide');
                } else {
                    $toggle.attr('aria-expanded', true)
                    associatedCollapse.collapse('show');
                }
            });
        });
    }, 1000);
}

// Pager popover toggler function
function legacyPagerToggle(toggleEl) {
    if ($(toggleEl).siblings('.popover-content-container').hasClass('hidden')) {
        $(toggleEl)
            .attr('aria-expanded', 'true')
            .siblings('.popover-content-container')
            .removeClass('hidden');
    } else {
        $(toggleEl)
            .attr('aria-expanded', 'false')
            .siblings('.popover-content-container')
            .addClass('hidden');
    }
}

// Toggle text toggler
function toggleText(el) {
    $(el).not('.toggle-text--collapse').each(function () {
        var $collapse = $(this);

        $collapse
            .addClass('toggle-text--collapse')
            .on('hide.bs.collapse show.bs.collapse', function () {
                var collapseID = $(this).attr('id');
                var toggleBtn = $('.toggle-text[data-target="#' + collapseID + '"], .toggle-text[href="#' + collapseID + '"]');
                var text = toggleBtn.first().text();

                toggleBtn
                    .text(toggleBtn.data('replace'))
                    .data('replace', text);
            });
    });
}

function getCookie(name) {
    let value = '; ${document.cookie}';
    let parts = value.split('; ${name}=');
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
}

function initializeGDPRCookie() {
    let gdprCookie = getCookie("AcceptGDPR");
    if (gdprCookie === undefined && !document.cookie.includes("AcceptGDPR")) {
        $("#GDPRBlock").removeClass("d-none");
    } else {
        $("#GDPRBlock").remove();
    }

    $("#GDPRBlock").on("click", ".btn-gdpr", function (e) {
        e.preventDefault();
        document.cookie = "AcceptGDPR=true; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";

        $("#GDPRBlock").slideUp("slow", function () {
            $(this).remove();
        })
    })
}

function addAsteriskToRequiredSelectOption() {
    $('.ValidationRequired select').each(function () {
        var $select = $(this);
        var valRequiredSelectOption = $select.find('option').first();

        if (!valRequiredSelectOption.text().includes('*')) {
            var optionText = valRequiredSelectOption.text();

            valRequiredSelectOption.text('*' + optionText);
        }
    });

    $('.ValidationRequired input').each(function () {
        var $input = $(this);
        var valRequiredInputOption = $input.first();

        if (!valRequiredInputOption.attr('placeholder').includes('*')) {
            var optionText = valRequiredInputOption.attr('placeholder');

            valRequiredInputOption.attr('placeholder', '*' + optionText);
        }
    });
}